import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import "./Newsroom.css";

import heroCity from "../assets/hero_city.jpg";
import top100 from "../assets/news/TOP100 .gif";
import watch from "../assets/news/21watch.png";
import cambridge from "../assets/news/cambridge.jpg";
import test1 from "../assets/news/test2.png";
import nvidia from "../assets/news/nvidia.png";

// add your new images here
import CamIndependent from "../assets/news/camindependent.png";
import ubs from "../assets/news/ubs.png";
import OxCam from "../assets/news/OxCam.png";

export default function Newsroom() {
  const reduce = useReducedMotion();

  const news = useMemo(
    () => [
      {
        slug: "uk-gov-sweden",
        type: "NEWS",
        date: "08/02/2026",
        title:
          "WPARK CHOSEN BY UK GOVERNMENT AS ONE OF 15 AI DELEGATIONS TO SWEDEN, OPENED BY UK BUSINESS MINISTER",
        image: test1,
        linkedinUrl:
          "https://www.linkedin.com/posts/mabel-chu-107020206_ai-mobility-physicalai-activity-7430292120009175041-p_8s?utm_source=share&utm_medium=member_desktop&rcm=ACoAADRUApcB0ybt6nrkmdl4EufH-H2x6sF06iA",
      },
      {
        slug: "nvidia",
        type: "NEWS",
        date: "15/01/2026",
        title: "WPARK JOIN NVIDIA INCEPTION PROGRAMME",
        image: nvidia,
        linkedinUrl:
          "https://www.linkedin.com/posts/jacky-chu-84b7ba179_nvidiainceptionprogramme-wpark-deeptech-activity-7419377103520960512-bdch?utm_source=share&utm_medium=member_desktop&rcm=ACoAADRUApcB0ybt6nrkmdl4EufH-H2x6sF06iA",
      },

      // new items
      {
        slug: "CamIndependent",
        type: "NEWS",
        date: "20/03/2026",
        title: "WPARK NAMED FINALIST AT THE CAMBRIDGE INDEPENDENT SCIENCE & TECHNOLOGY AWARDS",
        image: CamIndependent,
        linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7440827339720052736",
      },
      {
        slug: "UBS",
        type: "NEWS",
        date: "30/03/2026",
        title: "CO-FOUNDER MABEL SELECTED TO UBS PROJECT FOUNDER PROGRAMME ",
        image: ubs,
        linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7445904287605350400",
      },
      {
        slug: "OxCam",
        type: "NEWS",
        date: "23/03/2026",
        title: "FOUNDER JACKY ACCEPTED TO OXFORD CAMBRIDGE FELLOWSHIP",
        image: OxCam,
        linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7442157067198566400",
      },
      {
        slug: "techarena-top-100",
        type: "NEWS",
        date: "14/01/2026",
        title:
          "WPARK NAMED GLOBAL TOP 100 STARTUP BY TECHARENA, ONE OF TOP 10 EUROPEAN BUSINESS & TECH EVENTS RATED BY FORBES",
        image: top100,
        linkedinUrl:
          "https://www.linkedin.com/posts/wpark25_techarena-techarena2026-top100-activity-7417494916592754689-7Vc0?utm_source=share&utm_medium=member_desktop&rcm=ACoAADRUApcB0ybt6nrkmdl4EufH-H2x6sF06iA",
      },
      {
        slug: "21-to-watch",
        type: "NEWS",
        date: "16/01/2026",
        title:
          "WPARK LONGLISTED AS 21 TO WATCH IN CAMBRIDGE, CELEBRATING MOST INNOVATIVE COMPANIES",
        image: watch,
        linkedinUrl:
          "https://www.linkedin.com/posts/wpark25_21towatch-mobility-deeptech-activity-7419809996219097089-GOW1?utm_source=share&utm_medium=member_desktop&rcm=ACoAADRUApcB0ybt6nrkmdl4EufH-H2x6sF06iA",
      },
      {
        slug: "cambridge-accelerator",
        type: "NEWS",
        date: "14/12/2025",
        title:
          "WPARK JOINS ACCELERATE CAMBRIDGE, SUPPORTED BY CAMBRIDGE JUDGE BUSINESS SCHOOL",
        image: cambridge,
        linkedinUrl:
          "https://www.linkedin.com/posts/cjbsentrepreneurshipcentre_entrepreneurs-pitch-coaches-activity-7405255052581412866-zIEJ?utm_source=share&utm_medium=member_desktop&rcm=ACoAADRUApcB0ybt6nrkmdl4EufH-H2x6sF06iA",
      },
    ],
    []
  );

  const featuredNews = news.slice(0, 2);
  const moreNews = news.slice(2);

  const ease = [0.2, 0.8, 0.2, 1];

  const reveal = {
    hidden: reduce
      ? { opacity: 1, y: 0, filter: "blur(0px)" }
      : { opacity: 0, y: 14, filter: "blur(6px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.8, ease },
    },
  };

  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
  };

  const Tile = ({ item, size = "md" }) => {
    const isExternal = Boolean(item.linkedinUrl);

    const TileInner = (
      <>
        <div className="newsroom__media">
          <motion.img
            className="newsroom__img"
            src={item.image || heroCity}
            alt={item.title}
            loading="lazy"
            initial={reduce ? false : { scale: 1.01, opacity: 0.9 }}
            whileInView={reduce ? undefined : { scale: 1.001, opacity: 1 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 1.0, ease }}
          />

          <div className="newsroom__overlay">
            <span className="newsroom__type">{item.type}</span>
            <span className="newsroom__date">{item.date}</span>
          </div>

          <span className="newsroom__imgHint">IMAGE</span>
        </div>

        <h3 className="newsroom__headline">{item.title}</h3>
      </>
    );

    return (
      <motion.article
        variants={reveal}
        className={`newsroom__tile ${
          size === "lg" ? "newsroom__tile--lg" : "newsroom__tile--md"
        }`}
      >
        {isExternal ? (
          <a
            href={item.linkedinUrl}
            className="newsroom__tileLink"
            aria-label={`${item.title} (opens externally)`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {TileInner}
          </a>
        ) : (
          <Link
            to={`/news/${item.slug}`}
            className="newsroom__tileLink"
            aria-label={item.title}
          >
            {TileInner}
          </Link>
        )}
      </motion.article>
    );
  };

  return (
    <main className="newsroom">
      <header className="newsroom__header">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.6 }}
          className="newsroom__kicker"
        >
          NEWS &amp; MEDIA
        </motion.div>

        <motion.h1
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.6 }}
          className="newsroom__title"
        >
          NEWSROOM
        </motion.h1>
      </header>

      <motion.section
        className="newsroom__grid2"
        aria-label="Featured news"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
      >
        {featuredNews.map((item) => (
          <Tile key={item.slug} item={item} size="lg" />
        ))}
      </motion.section>

      <motion.section
        className="newsroom__grid3"
        aria-label="More news"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        {moreNews.map((item) => (
          <Tile key={item.slug} item={item} size="md" />
        ))}
      </motion.section>
    </main>
  );
}